<template>
  <div
    v-if="
      suggested_by_radius.departure.length ||
        suggested_by_radius.arrival.length ||
        suggested_by_radius.departure_arrival.length
    "
    class="flights-suggestions"
  >
    <div class="flights-suggestions--heading">Vola da un aeroporto vicino</div>
    <div class="content-panel panel">
      <div class="flights-suggestions--flights">
        <b-row>
          <b-col
            v-if="suggested_by_radius.departure.length"
            md="6"
            class="m-auto"
          >
            <div class="flights-suggestions--title">Parti da:</div>
            <div
              v-for="(suggestion, index) in suggested_by_radius.departure"
              :key="'or_dep_' + index + _uid"
              class="flights-suggestions--flight"
            >
              <div class="flights-suggestions--flight--left">
                <div class="text-tertiary semibold">
                  {{ suggestion.label_departure }}
                  ({{ suggestion.iata_code_departure }})
                </div>
                <div>
                  A partire da
                  <span
                    class="text-primary semibold"
                  >{{
                     apply_markup_to_number(
                       suggestion.flight_offer,
                       suggestion.min_price
                     )
                   }}
                    {{ suggestion.currencySymbol || suggestion.currency }}</span>
                </div>
              </div>
              <div class="flights-suggestions--flight--right">
                <vb-button
                  :vb_options="{ size: 'md', variant: 'info' }"
                  @click="
                    search_by_suggestion({
                      iata_code_departure: suggestion.iata_code_departure,
                      label_departure: suggestion.label_departure,
                    })
                  "
                >
                  Scopri!
                </vb-button>
              </div>
            </div>
          </b-col>
          <b-col
            v-if="suggested_by_radius.arrival.length"
            md="6"
            class="m-auto"
          >
            <div class="flights-suggestions--title">Arriva a:</div>
            <div
              v-for="(suggestion, index) in suggested_by_radius.arrival"
              :key="'or_arr_' + index + _uid"
              class="flights-suggestions--flight"
            >
              <div class="flights-suggestions--flight--left">
                <div class="text-tertiary semibold">
                  {{ suggestion.label_arrival }}
                  ({{ suggestion.iata_code_arrival }})
                </div>
                <div class="flights-suggestions--price">
                  A partire da
                  <span>{{ suggestion.min_price }}
                    {{ suggestion.currencySymbol || suggestion.currency }}</span>
                </div>
              </div>
              <div class="flights-suggestions--flight--right">
                <vb-button
                  :vb_options="{ size: 'md', variant: 'info' }"
                  @click="
                    search_by_suggestion({
                      iata_code_arrival: suggestion.iata_code_arrival,
                      label_arrival: suggestion.label_arrival,
                    })
                  "
                >
                  Scopri!
                </vb-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <div v-if="suggested_by_radius.departure_arrival.length">
          <!-- il copy "oppure" ha senso solo se sopra ci sono altre offerte -->
          <div
            v-if="
              suggested_by_radius.departure.length > 0 ||
                suggested_by_radius.arrival.length > 0
            "
            class="flights-suggestions--title"
          >
            Oppure:
          </div>

          <b-row>
            <b-col
              v-for="(
                suggestion, index
              ) in suggested_by_radius.departure_arrival"
              :key="'or_arr_' + index + _uid"
              md="6"
            >
              <div class="flights-suggestions--flight">
                <div class="flights-suggestions--flight--left">
                  <div class="text-tertiary">
                    <div>
                      Parti da:
                      <span
                        class="semibold"
                      >{{ suggestion.label_departure }} ({{
                        suggestion.iata_code_departure
                      }})</span>
                    </div>
                    <div>
                      Arriva a:
                      <span
                        class="semibold"
                      >{{ suggestion.label_arrival }} ({{
                        suggestion.iata_code_arrival
                      }})</span>
                    </div>
                  </div>
                  <div class="flights-suggestions--price">
                    A partire da
                    <span>{{ suggestion.min_price }}
                      {{
                        suggestion.currencySymbol || suggestion.currency
                      }}</span>
                  </div>
                </div>
                <div class="flights-suggestions--flight--right">
                  <vb-button
                    :vb_options="{ size: 'md', variant: 'info' }"
                    @click="
                      search_by_suggestion({
                        iata_code_arrival: suggestion.iata_code_arrival,
                        iata_code_departure: suggestion.iata_code_departure,
                        label_departure: suggestion.label_departure,
                        label_arrival: suggestion.label_arrival,
                      })
                    "
                  >
                    Scopri!
                  </vb-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { apply_markup_to_number } from '@liveflight/utilities/price';
  import {
    endpoint_label,
    update_origin_destination_by_index,
  } from '@liveflight/utilities/origin-destination';

  export default {
    name: 'flights-suggestions',
    data() {
      return {
        suggested_by_radius: {
          departure: [],
          arrival: [],
          departure_arrival: [],
        },
      };
    },
    computed: {
      suggestions() {
        return this.$store.state.liveflight.suggestions;
      },
      suggestions_by_radius() {
        const { by_radius = [] } = this.suggestions || {};
        return Array.isArray(by_radius) ? by_radius : [];
      },
      return_flight() {
        return this.$store.state.liveflight.return_flight;
      },
      origin_destinations() {
        return this.$store.state.liveflight.origin_destinations;
      },
      departure_airport() {
        const { departure = {} } = this.origin_destinations[0] || {};
        return departure.iata_code || '';
      },
      arrival_airport() {
        const { arrival = {} } = this.origin_destinations[0] || {};
        return arrival.iata_code || '';
      },
    },
    created() {
      this.apply_markup_to_number = apply_markup_to_number;
    },
    mounted() {
      this.get_suggested_by_radius_airports();
    },
    methods: {
      // ─── Normalized-offer helpers ───────────────────────────────────────
      endpoints(offer) {
        // Destination is firstArrival (outbound touchdown). On a round trip
        // lastArrival is the return touchdown (= the origin), which would
        // collapse every suggestion to origin->origin. For one-way offers the
        // two coincide, so this is a no-op there.
        const { firstDeparture = {}, firstArrival = {} } = offer || {};
        return {
          dep_code: firstDeparture.iataCode || '',
          arr_code: firstArrival.iataCode || '',
          dep_label: endpoint_label(firstDeparture),
          arr_label: endpoint_label(firstArrival),
        };
      },
      cheapest_with(offers, predicate) {
        return offers
          .filter(predicate)
          .sort((a, b) => a.price.grandTotal - b.price.grandTotal)[0];
      },

      // ─── Derived suggestions ────────────────────────────────────────────
      get_suggested_by_radius_airports() {
        const offers = this.suggestions_by_radius;
        const departure = [];
        const arrival = [];
        const departure_arrival = [];

        offers.forEach((offer) => {
          const { dep_code, arr_code, dep_label, arr_label } =
            this.endpoints(offer);

          // aeroporti con partenza diversa da quella della ricerca ma stesso arrivo
          if (
            dep_code !== this.departure_airport &&
            arr_code === this.arrival_airport &&
            !departure.some((s) => s.iata_code_departure === dep_code)
          ) {
            // calcolo il prezzo minore per offerte suggerite che abbiano questo aeroporto di partenza
            const min_price = this.cheapest_with(
              offers,
              (other) => this.endpoints(other).dep_code === dep_code
            );
            // tiro fuori tre chiavi per comodità, ma metto anche la flight_offer intera per gestire il click del pulsante
            departure.push({
              iata_code_departure: dep_code,
              label_departure: dep_label,
              min_price: min_price.price.grandTotal,
              currency: min_price.price.currency,
              currencySymbol: min_price.price.currencySymbol,
              flight_offer: min_price,
            });
          }

          // aeroporti con stessa partenza di quella della ricerca ma con arrivo diverso
          if (
            dep_code === this.departure_airport &&
            arr_code !== this.arrival_airport &&
            !arrival.some((s) => s.iata_code_arrival === arr_code)
          ) {
            const min_price = this.cheapest_with(
              offers,
              (other) => this.endpoints(other).arr_code === arr_code
            );
            arrival.push({
              iata_code_arrival: arr_code,
              label_arrival: arr_label,
              min_price: min_price.price.grandTotal,
              currency: min_price.price.currency,
              currencySymbol: min_price.price.currencySymbol,
              flight_offer: min_price,
            });
          }

          // aeroporti con diversa partenza e diverso arrivo rispetto a quelli della ricerca
          if (
            dep_code !== this.departure_airport &&
            arr_code !== this.arrival_airport &&
            !departure_arrival.some(
              (s) =>
                s.iata_code_departure === dep_code &&
                s.iata_code_arrival === arr_code
            )
          ) {
            const min_price = this.cheapest_with(offers, (other) => {
              const e = this.endpoints(other);
              return e.dep_code === dep_code && e.arr_code === arr_code;
            });
            departure_arrival.push({
              iata_code_departure: dep_code,
              iata_code_arrival: arr_code,
              label_departure: dep_label,
              label_arrival: arr_label,
              min_price: min_price.price.grandTotal,
              currency: min_price.price.currency,
              currencySymbol: min_price.price.currencySymbol,
              flight_offer: min_price,
            });
          }
        });

        this.suggested_by_radius = {
          departure,
          arrival,
          departure_arrival,
        };
      },
      search_by_suggestion(suggestion) {
        const changes = {};

        if (suggestion.iata_code_departure) {
          changes.departure = {
            iata_code: suggestion.iata_code_departure,
            label: suggestion.label_departure || suggestion.iata_code_departure,
          };
        }

        if (suggestion.iata_code_arrival) {
          changes.arrival = {
            iata_code: suggestion.iata_code_arrival,
            label: suggestion.label_arrival || suggestion.iata_code_arrival,
          };
        }

        const updated = update_origin_destination_by_index(
          this.origin_destinations,
          0,
          changes,
          this.return_flight
        );

        this.$store.commit('liveflight/origin_destinations', updated);
        window.eventBus.$emit('trigger-search-by-suggestion');
      },
    },
  };
</script>

<style lang="scss">
  .flights-suggestions {
    &--heading {
      text-align: left;
      color: var(--primary);
      font-size: 22px;
      margin-bottom: $grid-gutter-width / 3;
    }
    &--title {
      text-align: left;
      @include font-primary-regular;
      margin-top: 16px;
      margin-bottom: 20px;
      text-transform: uppercase;
    }
    &--flight {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid $light-gray;
      margin-bottom: 16px;
      padding-bottom: 16px;
      &--left {
        flex: 1;
        text-align: left;
        padding-right: 20px;
      }
      &--right {
        text-align: right;
      }
    }
    &--price {
      span {
        color: var(--primary);
        @include font-primary-bold;
      }
    }
  }
</style>
